import styled from 'styled-components';

export const NameCell = styled.td({
  maxWidth: 250,
});
